<template>
    <div>
        <h5 class="mb-2">{{title}}</h5>
        <div :id="'chartdiv' + type" style="height: 300px">
        </div>
    </div>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";

    am4core.options.commercialLicense = true;


    export default {
        name: "historicChart",
        props: {
            type: {
                required: true,
                type: String,
                validator: function (value) {
                    return ['temp', 'hum', 'co2', 'moisture'].indexOf(value.toLowerCase()) !== -1
                }
            },
            chartData: {
                type: Array
            }
        },
        data: function () {
            return {
                series: [],
                chart: undefined,
                noDataLabel: undefined,
                loadingInstance: undefined,
            }
        },
        mounted() {
            if (this.chart !== undefined) {
                this.chart.dispose();
            }
            this.chart = undefined;
            this.series = [];


            if (this.chartData !== undefined && this.chartData.length > 0) {
                setTimeout(() => {
                    this.drawChart();
                    this.refreshDataOnMap(this.chartData);
                    let hasData = this.chartData.flat().some(value => {
                        return value[this.type] !== undefined
                    });

                    if (this.noDataLabel) {
                        this.noDataLabel.text = hasData ? "" : this.$t('HISTORICS.NO_DATA_FOR_THIS_DATE');
                    }
                }, 1);
            }

        },
        computed: {
            title: function () {
                switch (this.type) {
                    case "temp":
                        return this.$t("COMMON.TEMPERATURE");
                    case "co2":
                        return this.$t("COMMON.CO2");
                    case "hum":
                        return this.$t("COMMON.HUMIDITY");
                    case "moisture":
                        return this.$t("COMMON.MOISTURE");
                }
            },
        },
        watch: {
            chartData: function (newVal) {
                if (this.chart !== undefined) {
                    this.chart.dispose();
                }
                this.chart = undefined;
                this.series = [];
                setTimeout(() => {
                    this.drawChart();
                    this.refreshDataOnMap(newVal);
                    let hasData = newVal.flat().some(value => {
                        return value[this.type] !== undefined
                    });

                    if (this.noDataLabel) {
                        this.noDataLabel.text = hasData ? "" : this.$t('HISTORICS.NO_DATA_FOR_THIS_DATE');
                    }
                }, 1);


            },
        },
        methods: {
            drawChart() {

                let chart = am4core.create("chartdiv" + this.type, am4charts.XYChart);
                this.chart = chart;

                let dateAxis = chart.xAxes.push(new am4charts.DateAxis());

                dateAxis.renderer.grid.template.disabled = true;

                dateAxis.groupData = true;
                dateAxis.groupIntervals.setAll([
                    {timeUnit: "second", count: 1},
                    {timeUnit: "second", count: 10},
                    {timeUnit: "minute", count: 1},
                    {timeUnit: "minute", count: 10},
                    {timeUnit: "hour", count: 1},
                    {timeUnit: "hour", count: 3},
                    {timeUnit: "day", count: 1},
                    {timeUnit: "day", count: 24},
                    {timeUnit: "week", count: 7},
                ]);


                dateAxis.dateFormats.setKey("day", "dd");
                dateAxis.periodChangeDateFormats.setKey("month", "[bold]MMM[/]");
                dateAxis.cursorTooltipEnabled = false;


                let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.renderer.grid.template.disabled = false;
                valueAxis.min = 0;
                /*if (this.type === "hum" || this.type === "moisture") {
                    valueAxis.max = 100;
                }
                */
                valueAxis.numberFormatter.numberFormat = "#.##' " + this.$store.getters.unit(this.type) + "'";
                valueAxis.cursorTooltipEnabled = false;


                this.chartData.forEach((section, index) => {
                    this.createSerie(chart, this.$t("HISTORICS.SECTION_NAME", {section: index + 1}))
                });

                chart.cursor = new am4charts.XYCursor();
                chart.cursor.lineY.disabled = true;
                chart.scrollbarX = new am4core.Scrollbar();
                chart.scrollbarX.parent = chart.bottomAxesContainer;

                if(this.$store.state.viewDetails == true)
                {
                    chart.legend = new am4charts.Legend();
                    chart.legend.position = "bottom";
                    chart.legend.contentAlign = "center";
                }

                

                let label = chart.createChild(am4core.Label);
                this.noDataLabel = label;
                label.text = "";
                label.fill = "#cccccc";
                label.fontSize = 20;
                label.align = "center";
                label.isMeasured = false;
                label.x = am4core.percent(50);
                label.horizontalCenter = "middle";
                label.y = am4core.percent(30);

            },
            createSerie(chart, name) {
                let series = chart.series.push(new am4charts.LineSeries());
                this.series.push(series);
                series.dataFields.valueY = this.type;
                series.dataFields.dateX = "dateObj";
                series.strokeWidth = 2;
                if(this.$store.state.viewDetails == true) {
                    series.name = name;
                }

                series.tooltip.background.strokeOpacity = 0;
                series.tooltip.pointerOrientation = "vertical";
                series.tooltip.label.minWidth = 40;
                series.tooltip.label.minHeight = 40;
                series.tooltip.label.textAlign = "start";
                series.tooltip.getFillFromObject = false;
                series.tooltip.background.fill = am4core.color("#212121");
                series.tooltip.background.fillOpacity = 0.7;
                series.tooltip.background.strokeWidth = 0;


                let bullet = series.bullets.push(new am4charts.CircleBullet());
                bullet.circle.strokeWidth = 2;
                bullet.circle.radius = 4;
                bullet.circle.fill = am4core.color("#fff");
                bullet.tooltipText = "{dateX.formatDate('dd-MM-yyyy HH:mm:ss')}\n {valueY} ";

                let bullethover = bullet.states.create("hover");
                bullethover.properties.scale = 1.3;

            },
            refreshDataOnMap(data) {
                if (this.chart !== undefined) {
                    for (let i = 0; i < data.length; i++) {
                        if (this.series[i] !== undefined) {
                            this.series[i].data = data[i];
                        }
                    }

                }

            }
        },
        beforeDestroy() {
            if (this.chart) {
                this.chart.dispose()
            }
        }
    }
</script>

<style lang="scss">
    @import '~bootstrap/scss/_functions';
    @import '~bootstrap/scss/_variables';
    @import '~bootstrap/scss/mixins/_breakpoints';

    .el-picker-panel {
        @include media-breakpoint-down(lg) {
            left: 0 !important;
        }
    }

</style>